/**
 * Product detail page breadcrumbs: Home › <collection> › <product>.
 *
 * - Collection identified (collection-scoped URL rendered server-side, or a
 *   same-origin collection page referrer containing this product): show it and
 *   move its handle to the front of the history in sessionStorage (newest
 *   first, deduped, at most MAX_HISTORY handles).
 * - Otherwise: show the most recent stored collection this product belongs
 *   to, else Home only. The history is never changed in this case.
 *
 * Markup and the product's collections map: snippets/product-breadcrumbs.liquid
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'pdpBreadcrumbCollections';
  var MAX_HISTORY = 50;
  var COLLECTION_PATH = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/([^\/]+)\/?/i;

  function readCollections() {
    var el = document.querySelector('[data-product-breadcrumbs-collections]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  function referrerHandle() {
    try {
      if (!document.referrer) return null;
      var url = new URL(document.referrer);
      if (url.origin !== window.location.origin) return null;
      if (url.pathname.indexOf('/products/') !== -1) return null;
      var match = url.pathname.match(COLLECTION_PATH);
      return match ? decodeURIComponent(match[1]).toLowerCase() : null;
    } catch (e) {
      return null;
    }
  }

  // Collection handles, most recent first
  function getHistory() {
    try {
      var history = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY));
      return Array.isArray(history) ? history : [];
    } catch (e) {
      return [];
    }
  }

  function remember(handle) {
    var history = getHistory();
    if (history[0] === handle) return;

    var index = history.indexOf(handle);
    if (index !== -1) history.splice(index, 1);
    history.unshift(handle);
    if (history.length > MAX_HISTORY) history.length = MAX_HISTORY;

    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(history));
    } catch (e) {}
  }

  // Inserts "<collection> ›" before the current product crumb
  function addCrumb(nav, collection) {
    var list = nav.querySelector('ol');
    if (!list) return;
    var current = list.querySelector('[aria-current="page"]');

    var separator = document.createElement('li');
    separator.setAttribute('aria-hidden', 'true');
    separator.textContent = '›';

    var item = document.createElement('li');
    var link = document.createElement('a');
    link.href = collection.url;
    link.textContent = collection.title;
    item.appendChild(link);

    list.insertBefore(item, current);
    list.insertBefore(separator, current);
  }

  function init() {
    var nav = document.querySelector('[data-product-breadcrumbs]');
    if (!nav) return;

    var serverHandle = nav.getAttribute('data-server-collection');
    if (serverHandle) {
      remember(serverHandle);
      return;
    }

    var collections = readCollections();
    var has = function (handle) {
      return !!handle && Object.prototype.hasOwnProperty.call(collections, handle);
    };

    var handle = referrerHandle();
    if (has(handle)) {
      remember(handle);
      addCrumb(nav, collections[handle]);
      return;
    }

    var history = getHistory();
    for (var i = 0; i < history.length; i++) {
      if (has(history[i])) {
        addCrumb(nav, collections[history[i]]);
        return;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
